<script lang="ts" setup>
  import { ref, watch } from 'vue'

  const props = defineProps<{
    modelValue: boolean
    serviceName: string
    loading?: boolean
  }>()

  const emits = defineEmits<{
    'update:modelValue': [value: boolean]
    'confirm': []
  }>()

  const confirmText = ref('')

  watch(
    () => props.modelValue,
    (open) => {
      if (open) {
        confirmText.value = ''
      }
    },
  )
</script>

<template lang="html">
  <v-dialog max-width="600" :model-value="modelValue" @update:model-value="emits('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-error">Delete prototype</v-card-title>

      <v-card-text>
        <p>
          You are about to permanently delete
          <b>{{ serviceName }}.</b>
          This cannot be undone and will:
        </p>

        <ul class="my-2">
          <li>Remove it from OuraHub.</li>
          <li>Archive its GitHub repository.</li>
          <li>Remove its deployed code from all environments.</li>
        </ul>

        <p>
          Type
          <b>{{ serviceName }}</b>
          below to confirm.
        </p>

        <v-text-field v-model="confirmText" class="mt-2" label="Prototype name" :placeholder="serviceName" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <o-btn-text text="Cancel" @click="emits('update:modelValue', false)" />
        <o-btn-error
          text="Delete"
          prepend-icon="mdi-delete"
          :loading="loading"
          :disabled="confirmText !== serviceName"
          @click="emits('confirm')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
